<template>
  <b-card-body class="p-0">
    <hr class="mt-0">
    <div
      v-if="previewAd"
      class="card w-100"
    >
      <div class="card-body bg-white">
        <div class="d-flex align-items-center justify-content-center">
          <b-img
            ref="squareAdImg"
            :src="url"
            fluid
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="d-flex justify-content-center align-items-center py-2"
    >
      <span>
        {{ $tk('ClientPortal.Form.AdCreation.NoImageHasBeenSelectedYet') }}
      </span>
    </div>
  </b-card-body>
</template>

<script>
export default {
  props: {
    previewAd: {
      type: [Boolean],
    },
    url: {
      type: [String],
    },
  },
}
</script>
